import { cr, URLS, mo, ck, interact } from "fire-wind-water";
import { $cmsData, settings } from "../common/setting";
import { scmsService } from "../services/site";
import { user } from "../user/index";
import * as $ from "jquery";

class searchDetail {
  $skelem = ".sk-cms-search-get";
  $user: any = {};
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  tid: string = settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  fid: string = URLS.getURL("fid");
  title = "";
  body = "";
  time = "";
  preview = "";
  down = "";
  size = "";
  recommendNum = 6;
  recommendStyle = {};
  titleStyle = {};
  keywordStyle = {};
  tabFlag = true;
  backFlag = false;
  descStyle = {};
  submitting = false;
  type = "";
  defaultIndex = 0; // 默认选中的index
  constructor() {
    $sk.template.module(this);
  }
  skAfterViewChecked(): void {
    if (this.isDesign) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "SEARCHDETAIL") {
            if (d.historyContent?.content.searchHistory) {
              this.initSearchHistory(
                d.historyContent?.content.searchHistory,
                d.historyContent.style.keyword
              );
            }
            if (d.historyContent?.content.dataList) {
              this.initDataList(
                d.historyContent?.content.dataList,
                d.historyContent.style.title,
                d.historyContent.style.desc
              );
            }
          }
        });
      });
    } else {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "SEARCHDETAIL") {
            this.keywordStyle = d.historyContent.style.keyword;
            this.titleStyle = d.historyContent.style.title;
            this.descStyle = d.historyContent.style.desc;
            d.historyContent.content.items.forEach((o, i) => {
              if (o.isDefault == 1) {
                this.type = o.type;
                this.defaultIndex = i;
              }
            });
          }
        });
      });
      setTimeout(() => {
        $("#search-input")
          .focus()
          .on("submit", () => {
            const keyword = $("#search-input").val();
          });
      }, 100);
      ck.json = true;
      $("#search-input").keydown((event) => {
        if (event.keyCode == 13) {
          const keyword = $("#search-input").val();
          this.setKeyword(keyword);
          this.tabFlag = false;
          $("#search-tab>.item:eq(this.defaultIndex)").click();
          this.search(this.type);
        }
      });
      $("#search-tab").hide();
      this.getSearchHistory(this.keywordStyle);
    }
  }
  setKeyword(keyword) {
    if (!keyword || keyword.length == 0) {
      return;
    }
    const list = ck.cookie("search-keyword-list") || [];
    if (list.indexOf(keyword) > -1) {
      list.splice(list.indexOf(keyword), 1);
    }

    list.unshift(keyword);
    ck.cookie("search-keyword-list", list);
  }
  skUserEnd() {
    this.updateUser();
  }
  updateUser() {
    const m = $sk.template.get();
    if (m.user.session) {
      this.$user.session = m.user.session;
    }
  }
  getSearchHistory(keywordStyle) {
    const hList = ck.cookie("search-keyword-list");
    if (hList) {
      if (!keywordStyle.color) {
        keywordStyle = $("#keyword-style").html();
        if (keywordStyle) {
          keywordStyle = JSON.parse(keywordStyle);
        }
      }
      this.initSearchHistory(hList, keywordStyle);
    }
  }
  checkSearch(e){
    this.search('');
  }
  checkTab(e, type, index, active, tab) {
    this.type = type;
    if (this.isDesign) {
      return;
    }
    if (this.submitting) {
      return;
    }
    if (!active.color) {
      active = $("#search-tab-active-style").html();
      if (active) {
        active = JSON.parse(active);
      }
    }
    if (!tab.color) {
      tab = $("#search-tab-style").html();
      if (tab) {
        tab = JSON.parse(tab);
      }
    }
    $("#search-tab>.item").removeClass("active");
    if (tab.model != "default") {
      $("#search-tab>.item").css("color", tab.color);
    }
    $("#search-tab>.item:eq(" + index + ")").addClass("active");
    if (active.model != "default") {
      $("#search-tab>.item:eq(" + index + ")")
        .css("color", active.color)
        .css("border-bottom-color", active.color);
    }
    if (this.tabFlag) {
      this.search(type);
    }
  }
  checkKeyword(e, keyword) {
    if (this.isDesign) {
      return;
    }
    if (this.submitting) {
      return;
    }
    this.setKeyword(keyword);
    $("#search-input").val(keyword);
    this.tabFlag = false; //是否需要去搜做
    $("#search-tab>.item:eq(this.defaultIndex)").click();
    this.search(this.type);
  }
  search(type) {
    if (this.submitting) {
      return;
    }

    $("#search-tab").show();
    $("#history-area").hide();
    $(".no-data").hide();
    $(".data-loading").show();
    $("#search-data-list .item").remove();
    const prarm = {
      keyword: $("#search-input").val(),
      category: interact.isMobile ? 2 : 1,
      type: type || this.type,
      siteId: settings.siteId,
      tenantId: this.tid,
      start: 0,
      num: 50,
    };
    this.submitting = true;
    scmsService.search(prarm).subscribe((data) => {
      if (data.result == 0) {
        this.submitting = false;
        $(".data-loading").hide();
        $("#search-data-list").show();
        this.tabFlag = true;
        this.backFlag = true;
        if (data.content.items.length > 0) {
          $(".no-data").hide();
          this.initDataList(
            data.content.items,
            this.titleStyle,
            this.descStyle
          );
        } else {
          $("#search-data-list .item").remove();
          $(".no-data").show();
        }
      }
    });
  }
  initSearchHistory(list, style) {
    let html = "";
    cr.each(list, (r, index) => {
      if (index < 10) {
        html += `<div class="item" sk-event.click="checkKeyword('${r}')"  style="background-color: ${
          style && style.model == "custom" ? style.color2 : ""
        };color: ${
          style && style.model == "custom" ? style.color : ""
        }">${r}</div>`;
      }
    });
    $("#search-keyword-list").html(html);
    this.skUpdateView();
    // $renderComponent({ type: "SEARCHDETAIL" }, 2);
  }
  initDataList(list, style, style2) {
    let html = "";
    if (!style.color) {
      style = $("#search-data-title-style").html();
      if (style) {
        style = JSON.parse(style);
      }
    }
    if (!style2.color) {
      style2 = $("#search-data-desc-style").html();
      if (style2) {
        style2 = JSON.parse(style2);
      }
    }
    cr.each(list, (r, index) => {
      html += `<a href="${
        r.linkUrl || "javascript:void(0)"
      }"><div class="item" sk-event.click="goLink2('${r.linkUrl}')">
                <div class="title" sk-event.click="goLink2('${
                  r.linkUrl
                }')" style="color: ${
        style && style.styleType == "custom" ? style.color : ""
      }">${r.title}</div>    
        <div class="desc" sk-event.click="goLink2('${
          r.linkUrl
        }')" style="color: ${
        style2 && style2.styleType == "custom" ? style2.color : ""
      };display: 
                  ${style2.styleType == "hide" ? "none" : ""}">${
        r.desc || ""
      }</div>
              </div></a>`;
    });
    $("#search-data-list .item").remove();
    $("#search-data-list").append(html);
  }
  clearKeyword(e) {
    ck.cookie("search-keyword-list", []);
    this.getSearchHistory(this.keywordStyle);
  }
  goBack() {
    if (this.backFlag) {
      $("#search-tab").hide();
      this.getSearchHistory(this.keywordStyle);
      $("#history-area").show();
      $("#search-data-list .item").remove();
      $("#search-input").val("");
      this.backFlag = false;
    } else {
      window.history.go(-1);
    }
  }
  inputChange(e) {
    if (!e.target.value) {
      $("#search-tab").hide();
      this.getSearchHistory(this.keywordStyle);
      $("#history-area").show();
      $("#search-data-list .item").remove();
      $("#search-data-list").hide();
      $("#search-input").val("");
    }
  }
  skUpdateView(): void {}
}
export { searchDetail };
